module.exports = __webpack_public_path__ + "static/media/icon-supplies-toiletpaper.3189d114.svg";